import React, { ReactNode } from "react";

interface ProfileCardProps {
  children: ReactNode;
  className?: string;
}

export const ProfileCard = ({
  children,
  className = "",
}: ProfileCardProps) => (
  <section
    className={`rounded-[6px] border-2 border-[#002959] bg-[linear-gradient(145deg,#1b4b86_0%,#002959_100%)] px-[20px] pb-[30px] pt-[20px] shadow-[4px_4px_4px_rgba(0,0,0,0.15)] md:px-[30px] ${className}`}
  >
    {children}
  </section>
);

export const ProfileCardTitle = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-[55px] items-center gap-[15px] border-b border-white/50 py-[10px]">
    <div className="w-[4px] self-stretch rounded-[2px] bg-[#d4f754]" />
    <h2 className="font-['Noto_Sans_JP'] text-[20px] font-bold leading-[1.6] text-white md:text-[22px]">
      {children}
    </h2>
  </div>
);

export const LightProfileCard = ({
  children,
  className = "",
}: ProfileCardProps) => (
  <section
    className={`rounded-[6px] border-2 border-[#1b4b86] bg-[#eef5fa] px-[20px] pb-[30px] pt-[20px] md:px-[30px] ${className}`}
  >
    {children}
  </section>
);

export const LightProfileCardTitle = ({
  children,
}: {
  children: ReactNode;
}) => (
  <div className="flex min-h-[55px] items-center gap-[15px] border-b border-[#d5d5d5] py-[10px]">
    <div className="w-[4px] self-stretch rounded-[2px] bg-[#1b4b86]" />
    <h2 className="font-['Noto_Sans_JP'] text-[20px] font-bold leading-[1.6] text-[#1b4b86] md:text-[22px]">
      {children}
    </h2>
  </div>
);
